import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingSpinnerProps {
    message: string,
    messageLocation?: string
}

export const LoadingSpinnerSmallTextInside = ({ message, messageLocation="outside" }: LoadingSpinnerProps) => {
    return (
        <div className="align-items-center" style={{fontSize: "12px"}}>
            <span>
                <Spinner animation="border" variant="secondary" />
            </span> 
            <div
            style={{
                position: "absolute",
                left: "calc(50% - 15px)",
                top: "18px",
                width: "30px",
                height: "30px",
                //backgroundColor: "#dc35457a",
                fontSize: "8pt",
            }}
            >
                {message}
            </div>
        </div>
    );
}

